<template>
  <div class="accordion-item">
    <div class="accordion-heading content-bg" @click="activateContent">
      <h3>{{item.heading}}</h3>
    </div>
    <transition name="height">
      <div class="accordion-content" v-if="contentActive">
        <div v-html="item.content" @click="highlightField('content')"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AccordionItem',

  data() {
    return {
      contentActive: false
    }
  },

  props: {
    item: Object
  },

  methods: {
    activateContent() {
      this.contentActive = !this.contentActive
      this.highlightField('heading')
    },

    highlightField(value) {
      this.$emit('highlightField', value)
    }
  }
}
</script>

<style lang="sass">
  @import '../../../stylesheets/base/variables'

  .accordion-item
    margin-bottom: $gap-medium

  .accordion-content
    padding: $gap-medium 0

  .accordion-heading
    cursor: pointer
</style>
